module.exports = __webpack_public_path__ + "img/24.855007b8.svg";